import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { DayEntryShell } from './entry/DayEntryShell'
import { PhotosTab } from './report/PhotosTab'
import { WorkTab } from './report/WorkTab'

/**
 * Direct route to work completion.
 *
 * <p>Photographs sit on the same screen rather than behind another tab, because the
 * evidence is taken at the moment the quantity is recorded — asking someone to come back
 * later and attach it is how reports end up with no photographs at all.</p>
 */
export function WorkEntryPage() {
  return (
    <DayEntryShell
      title="Work completion"
      subtitle="Record quantities completed against the site BOQ, and attach the photographs that prove them."
    >
      {(report, editable) => (
        <>
          <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Quantities completed
            </Typography>
            <WorkTab reportId={report.id} editable={editable} />
          </Paper>

          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Photographs
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <PhotosTab reportId={report.id} editable={editable} />
          </Paper>

          <Box sx={{ height: 24 }} />
        </>
      )}
    </DayEntryShell>
  )
}
